'use es6';

const SPACE = String.fromCharCode(0x0020);
const TAB = String.fromCharCode(0x0009);
const TRAILING_WHITESPACE = [SPACE, SPACE, TAB, TAB, SPACE, SPACE, TAB].join('');
const LEADING_SPACES = [SPACE, SPACE, SPACE, SPACE].join('');
const LEADING_TABS = [TAB, TAB].join('');
export const DEMO_HUBL_CODE = `
{# Comment #}
<div class="line-wrapping">
  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
</div>
{% macro tacoConstructor(fixin, spicy) %}
  {{ caller() }}
  <dd>{{ fixin }}{%- for spice in range(spicy) -%}+ HOT{%-endfor -%}</dd>
{% endmacro %}

{% setx total = module.tacos|length %}
<h1> Taco Menu: </h1>
<dl>
{% for taco in module.tacos %}
    {%- call tacoConstructor(taco.fixin, taco.spicy) -%}
      <dt class="{{'vegan-' if taco.is_vegan else ''}}shell taco">The {{ taco.moniker|upper ~ ':'}}</dt>
    {%- endcall -%}
{% endfor %}
</dl>
`.trim();
export const DEMO_JS_CODE = `
/*
 * Block comment
 */
function Taco(fixin, spicy) {
  this.fixin = fixin;
  this.spicy = ' + HOT'.repeat(spicy);
}

var lineWrapping = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';

// Line comment
var tacos = ['Pescado', 'Carnitas', 'Pollo', 'Chorizo', 'Carne asada'];
for (var index = tacos.length; index--;) {
  var taco = tacos[index];
  console.log(taco);
}

var trailingWhitespace = true;${TRAILING_WHITESPACE}
${LEADING_SPACES}var leadingSpaces = true;
${LEADING_TABS}var leadingTabs = true;
`.trim();
export const DEMO_CSS_CODE = `
.taco {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAB9AAAAAUCAYAAADV5qZVAAAA3klEQVR42u3ZAREAEAAEsFdFN9EVkID7GrYaG2fNHQAAAAAAAAD43BDoAAAAAAAAACDQAQAAAAAAAKAEOgAAAAAAAABEoAMAAAAAAABACXQAAAAAAAAAiEAHAAAAAAAAgBLoAAAAAAAAABCBDgAAAAAAAAAl0AEAAAAAAAAgAh0AAAAAAAAASqADAAAAAAAAQAQ6AAAAAAAAAJRABwAAAAAAAIAIdAAAAAAAAAAogQ4AAAAAAAAAEegAAAAAAAAAUAIdAAAAAAAAACLQAQAAAAAAAKAEOgAAAAAAAAA8F85rL21XDp0aAAAAAElFTkSuQmCC);
}

.taco:not([class*='vegan']) {
  background-color: FireBrick;
}

.taco.vegan-shell{
  background-color: Chartreuse;
}
`.trim();